import type { Enum } from './enum';

export const LANGUAGES = {
  EN: 'EN',
  FR: 'FR',
  DE: 'DE',
  ES: 'ES',
  PT: 'PT',
  IT: 'IT',
  RU: 'RU',
  JA: 'JA',
  ZH: 'ZH',
  HU: 'HU',
  RO: 'RO',
  DA: 'DA',
  NL: 'NL',
  AZ: 'AZ',
} as const;
export type LANGUAGES = Enum<typeof LANGUAGES>;
